<template>
  <div class="resource-card" :class="{ video: video }">
    <div class="card-content">
      <div>
        <div class="card-name" @click="goPage(cardInfo)">
          {{ cardInfo.name }}
        </div>
        <div v-if="showConnect || cardInfo.user">
          <div class="connect-user" v-if="cardInfo.user.openId">
            <a
              @mouseover="hover = true"
              @mouseleave="hover = false"
              target="_blank"
              :href="
                'cloudhub://chat?openId=' +
                (cardInfo.user && cardInfo.user.openId)
              "
              ><img :src="hover ? yunzhijia_hover : yunzhijia" /> &nbsp;<span
                style="line-height: 17px"
                >点击获取体验账号</span
              ></a
            >
          </div>
          <div class="connect-user" v-else>
            <img style="width: 14px; height: 14px" :src="user" />
            <span> &nbsp;可自行申请体验账号</span>
          </div>
        </div>
      </div>
      <div>
        <div class="card-msg">{{ cardInfo.msg }}</div>
        <div>
          <span
            class="card-tag"
            v-for="(item, index) in cardInfo.tags"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :title="cardInfo.name">
      <video :src="currentVideoUrl" controls></video>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import Axios from "axios";
import { getUserAuditPostUrl } from "@/assets/js/const";
import user from "@/assets/img/resource/user.png";
import yunzhijia from "@/assets/img/resource/yunzhijia.png";
import yunzhijia_hover from "@/assets/img/resource/yunzhijia_hover.png";
export default {
  name: "",
  props: {
    cardInfo: {},
    showConnect: true,
    video: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user,
      yunzhijia,
      yunzhijia_hover,
      hover: false,
      dialogVisible: false,
      currentVideoUrl: "",
    };
  },
  methods: {
   async goPage(cardInfo) {
      let { data } = await Axios.get(getUserAuditPostUrl);
      console.log("data", data);
      // this.form.coverPhoto = { url: url };
      let {url,videoUrl} = cardInfo
      if (_.isUndefined(url)) {
        this.currentVideoUrl = videoUrl;
        this.dialogVisible = true;
      } else {
        window.open(this.cardInfo.url);
      }
    },
    goYun(openId) {
      window.open("cloudhub://chat");
      window.open("cloudhub://chat?openId=" + openId);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.resource-card {
  width: 280px;
  height: 145px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  padding: 21px 21px;
  display: flex;
  justify-content: space-between;
  &:hover {
    box-shadow: 2px 2px 16px 2px rgba(5, 5, 5, 0.06);
  }
  > img {
    width: 40px;
    height: 40px;
  }
  > .card-content {
    width: 192px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    text-align: left;
    .card-name {
      font-weight: bold;
      line-height: 2;
      &:hover {
        cursor: pointer;
        color: #e70012;
      }
    }
    .card-msg {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 194px;
    }
    > div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 14px;
      color: #333;
    }
    .connect-user {
      color: #999999;
      font-size: 12px;
      display: flex;
      align-items: flex-start;
      margin-top: 8px;
      img {
        width: 16px;
        height: 16px;
        vertical-align: bottom;
      }
      a {
        color: #999999;
        font-size: 12px;
        text-decoration: none;
        &:hover {
          color: #e70012;
        }
      }
    }
    .card-tag {
      display: inline-block;
      padding: 2px 6px 1px;
      font-size: 12px;
      color: #999;
      border-radius: 10px;
      border: 1px solid #999;
      margin-right: 8px;
      margin-top: 8px;
    }
  }
}

.resource-card.video {
  padding: 10px;
  display: flex;
  align-items: flex-start;
  .card-content {
    width: 100%;
    > div {
      height: auto;
    }
    .card-name {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      line-height: 1.5;
    }
    .card-msg {
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      line-height: 1.5;
      min-height: 42px;
    }
  }
}
</style>
